// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadButton_wrapper__Crko9","icon":"DownloadButton_icon__Jz02n"};